import request from '@/utils/request'

// crm 新建聯繫人
export function crmContactsSave(data) {
  return request({
    url: 'crm/contacts/save',
    method: 'post',
    data: data
  })
}

// crm 列表
export function crmContactsIndex(data) {
  return request({
    url: 'crm/contacts/index',
    method: 'post',
    data: data
  })
}

// 刪除
export function crmContactsDelete(data) {
  return request({
    url: 'crm/contacts/delete',
    method: 'post',
    data: data
  })
}

// crm 列表
export function crmContactsUpdate(data) {
  return request({
    url: 'crm/contacts/update',
    method: 'post',
    data: data
  })
}

// crm 詳情
export function crmContactsRead(data) {
  return request({
    url: 'crm/contacts/read',
    method: 'post',
    data: data
  })
}

/**
 * 聯繫人轉移
 * @param {*} data
 * contacts_id 	聯繫人陣列
 * owner_user_id 	變更負責人
 * is_remove 1移出，2轉為團隊成員
 * type 許可權 1只讀2讀寫
 */
export function crmContactsTransfer(data) {
  return request({
    url: 'crm/contacts/transfer',
    method: 'post',
    data: data
  })
}

/**
 * 聯繫人導出
 * @param {*} data
 *
 */
export function crmContactsExcelExport(data) {
  return request({
    url: 'crm/contacts/excelExport',
    method: 'post',
    data: data,
    responseType: 'blob',
    timeout: 600000
  })
}

/**
 * 聯繫人匯入
 * @param {*} data
 *
 */
export function crmContactsExcelImport(data) {
  var param = new FormData()
  Object.keys(data).forEach(key => {
    param.append(key, data[key])
  })
  return request({
    url: 'crm/contacts/excelImport',
    method: 'post',
    data: param,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 600000
  })
}

/**
 * 聯繫人匯入模板下載
 * @param {*} data
 *
 */
export const crmContactsExcelDownloadURL = 'crm/contacts/excelDownload'

/**
 * 關聯和取消關聯商機/聯繫人
 * @param {*} data
 */
export function crmContactsRelationAPI(data) {
  return request({
    url: 'crm/contacts/relation',
    method: 'post',
    data: data
  })
}
